let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("45jBE")).then(() => parcelRequire('kF6Sm'));